/*
 * @Author: zhangxiaoda zhangxiaoda@nextmar.com
 * @Date: 2025-05-07 14:28:22
 * @LastEditors: zhangxiaoda zhangxiaoda@nextmar.com
 * @LastEditTime: 2025-05-07 14:29:44
 * @FilePath: /zeelool-nextjs/src/components/PrescriptionFormV2/UnionDialog.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Dialog from '@/components/Dialog';
import { useTranslations } from '@/i18n/use-translations';

export default function UnionDialog({
  unionShow,
  onOk,
  onClose,
}: {
  unionShow: boolean;
  onOk: () => void;
  onClose: () => void;
}) {
  const t = useTranslations('prescriptionForm.dialogs.union');
  return (
    <Dialog.Confirm
      open={unionShow}
      okText={t('confirm')}
      onOk={onOk}
      onClose={onClose}
      sx={{
        '& .MuiPaper-root': {
          maxWidth: '472px',
        },
      }}
    >
      {t('title')}
    </Dialog.Confirm>
  );
}
